import { Linkedin } from "@/components/icons/linkedin";
import { DetailSection } from "@/components/freelancers/DetailSection";
import { useFreelancerPainel } from "@/hooks/use-freelancer-resumo-rapido";
import { LinkedInResumo } from "./LinkedInResumo";

/** Resumo, experiências e skills lidos do LinkedIn, na ficha. Some quando não há nada lido. */
export function FreelancerLinkedInPerfil({ freelancerId }: { freelancerId: string }) {
  const { data, isLoading } = useFreelancerPainel(freelancerId);
  const linkedin = data?.linkedin;
  const temConteudo = !!linkedin && (!!linkedin.headline || !!linkedin.cargo_atual || linkedin.experiencias.length > 0);
  if (!isLoading && !temConteudo) return null;

  return (
    <DetailSection title="Perfil do LinkedIn" icon={Linkedin} description="O que a plataforma leu do perfil público.">
      <LinkedInResumo linkedin={linkedin} isLoading={isLoading} completo />
    </DetailSection>
  );
}
